/**
 * Timestamp helpers for the read-only "Date and Time" field of the calling
 * summary modal. The stamp is captured once when the modal opens.
 */

/** Eastern time zone used for the displayed call timestamp. */
const EASTERN_TIME_ZONE = "America/New_York";

/**
 * Returns the current Eastern date and time formatted for display.
 *
 * @return Timestamp string such as `07/23/2026 12:20 EST`
 */
export const getCurrentEstTimestamp = (): string => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: EASTERN_TIME_ZONE,
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(new Date());

  const getPart = (type: Intl.DateTimeFormatPartTypes): string =>
    parts.find((part) => part.type === type)?.value ?? "";

  const hour = getPart("hour") === "24" ? "00" : getPart("hour");

  return `${getPart("month")}/${getPart("day")}/${getPart("year")} ${hour}:${getPart("minute")} EST`;
};

/**
 * Extracts the MM/DD/YYYY portion of a timestamp produced by
 * {@link getCurrentEstTimestamp}, used as the stored called date.
 *
 * @input timestamp - Display timestamp such as `07/23/2026 12:20 EST`
 * @return Date portion in MM/DD/YYYY format
 */
export const extractDatePart = (timestamp: string): string =>
  timestamp.trim().split(" ")[0] ?? "";
